var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "graph2",
      style: `height:${_vm.height}; width:${_vm.width}`,
    },
    [_c("canvas", { attrs: { id: _vm.id, width: 500 * 2, height: 400 } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }